export interface ContentHeaderBreadcrumb {
  title?: string;
  iconName?: string;
  routerLink?: string;
  navigateBack?: boolean;
}

export class ContentHeaderBreadcrumbHelper {
  static back(): ContentHeaderBreadcrumb {
    return {
      title: $localize`Back`,
      iconName: 'chevron-left',
      navigateBack: true,
    };
  }
}
